export const WETH_ABI = [
    {
        constant: true,
        inputs: [],
        name: 'name',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: 'guy',
                type: 'address',
            },
            {
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: 'src',
                type: 'address',
            },
            {
                name: 'dst',
                type: 'address',
            },
            {
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'withdraw',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                name: '',
                type: 'uint8',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: 'dst',
                type: 'address',
            },
            {
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: false,
        inputs: [],
        name: 'deposit',
        outputs: [],
        payable: true,
        stateMutability: 'payable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '',
                type: 'address',
            },
            {
                name: '',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        payable: true,
        stateMutability: 'payable',
        type: 'fallback',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'src',
                type: 'address',
            },
            {
                indexed: true,
                name: 'guy',
                type: 'address',
            },
            {
                indexed: false,
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'src',
                type: 'address',
            },
            {
                indexed: true,
                name: 'dst',
                type: 'address',
            },
            {
                indexed: false,
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'dst',
                type: 'address',
            },
            {
                indexed: false,
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'Deposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'src',
                type: 'address',
            },
            {
                indexed: false,
                name: 'wad',
                type: 'uint256',
            },
        ],
        name: 'Withdrawal',
        type: 'event',
    },
];
export const GENERIC_SWAP_ABI = [
    {
        inputs: [
            { internalType: 'address', name: '_uniswapPermit2', type: 'address' },
            { internalType: 'address', name: '_allowanceTarget', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    { inputs: [], name: 'AlreadyFilled', type: 'error' },
    { inputs: [], name: 'InsufficientOutput', type: 'error' },
    { inputs: [], name: 'InvalidMsgValue', type: 'error' },
    { inputs: [], name: 'InvalidSignature', type: 'error' },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'swapHash',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'maker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'taker',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'inputToken',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'inputAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'outputToken',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'outputAmount',
                type: 'uint256',
            },
        ],
        name: 'Swap',
        type: 'event',
    },
    {
        inputs: [],
        name: 'EIP191_HEADER',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_NAME',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_SEPARATOR',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_VERSION',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'allowanceTarget',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'originalChainId',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address payable', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'takerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'takerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'address', name: 'makerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'makerTokenAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'minMakerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'expiry', type: 'uint256' },
                    { internalType: 'uint256', name: 'salt', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                    { internalType: 'bytes', name: 'strategyData', type: 'bytes' },
                ],
                internalType: 'struct GenericSwapData',
                name: 'swapData',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'takerTokenPermit', type: 'bytes' },
        ],
        name: 'executeSwap',
        outputs: [
            { internalType: 'uint256', name: 'returnAmount', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address payable', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'takerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'takerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'address', name: 'makerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'makerTokenAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'minMakerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'expiry', type: 'uint256' },
                    { internalType: 'uint256', name: 'salt', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                    { internalType: 'bytes', name: 'strategyData', type: 'bytes' },
                ],
                internalType: 'struct GenericSwapData',
                name: 'swapData',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'takerTokenPermit', type: 'bytes' },
            { internalType: 'address', name: 'taker', type: 'address' },
            { internalType: 'bytes', name: 'takerSig', type: 'bytes' },
        ],
        name: 'executeSwap',
        outputs: [
            { internalType: 'uint256', name: 'returnAmount', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'originalEIP712DomainSeparator',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'permit2',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    { stateMutability: 'payable', type: 'receive' },
];
export const UNIAGENT_SWAP_ABI = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_uniswapPermit2',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_allowanceTarget',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'InsufficientBalance',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidMsgValue',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NominationExists',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotNominated',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotOwner',
        type: 'error',
    },
    {
        inputs: [],
        name: 'Permit2DataEmpty',
        type: 'error',
    },
    {
        inputs: [],
        name: 'ZeroOwner',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnerChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnerNominated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'router',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'inputToken',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'inputAmount',
                type: 'uint256',
            },
        ],
        name: 'Swap',
        type: 'event',
    },
    {
        inputs: [],
        name: 'acceptOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'allowanceTarget',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum IUniAgent.RouterType',
                name: 'routerType',
                type: 'uint8',
            },
            {
                internalType: 'address',
                name: 'inputToken',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'inputAmount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'payload',
                type: 'bytes',
            },
            {
                internalType: 'bytes',
                name: 'userPermit',
                type: 'bytes',
            },
        ],
        name: 'approveAndSwap',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'tokens',
                type: 'address[]',
            },
        ],
        name: 'approveTokensToRouters',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'nominateNewOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nominatedOwner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'permit2',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'tokens',
                type: 'address[]',
            },
            {
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
        ],
        name: 'rescueTokens',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'enum IUniAgent.RouterType',
                name: 'routerType',
                type: 'uint8',
            },
            {
                internalType: 'address',
                name: 'inputToken',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'inputAmount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'payload',
                type: 'bytes',
            },
            {
                internalType: 'bytes',
                name: 'userPermit',
                type: 'bytes',
            },
        ],
        name: 'swap',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
export const GS_EIP712_TYPES = {
    GenericSwapData: [
        {
            name: 'maker',
            type: 'address',
        },
        {
            name: 'takerToken',
            type: 'address',
        },
        {
            name: 'takerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'makerToken',
            type: 'address',
        },
        {
            name: 'makerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'minMakerTokenAmount',
            type: 'uint256',
        },
        {
            name: 'expiry',
            type: 'uint256',
        },
        {
            name: 'salt',
            type: 'uint256',
        },
        {
            name: 'recipient',
            type: 'address',
        },
        {
            name: 'strategyData',
            type: 'bytes',
        },
    ],
};
export const PERMIT2_ABI = [
    {
        inputs: [{ internalType: 'uint256', name: 'deadline', type: 'uint256' }],
        name: 'AllowanceExpired',
        type: 'error',
    },
    { inputs: [], name: 'ExcessiveInvalidation', type: 'error' },
    {
        inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
        name: 'InsufficientAllowance',
        type: 'error',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'maxAmount', type: 'uint256' }],
        name: 'InvalidAmount',
        type: 'error',
    },
    { inputs: [], name: 'InvalidContractSignature', type: 'error' },
    { inputs: [], name: 'InvalidNonce', type: 'error' },
    { inputs: [], name: 'InvalidSignature', type: 'error' },
    { inputs: [], name: 'InvalidSignatureLength', type: 'error' },
    { inputs: [], name: 'InvalidSigner', type: 'error' },
    { inputs: [], name: 'LengthMismatch', type: 'error' },
    {
        inputs: [
            { internalType: 'uint256', name: 'signatureDeadline', type: 'uint256' },
        ],
        name: 'SignatureExpired',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint160',
                name: 'amount',
                type: 'uint160',
            },
            {
                indexed: false,
                internalType: 'uint48',
                name: 'expiration',
                type: 'uint48',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
        ],
        name: 'Lockdown',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint48',
                name: 'newNonce',
                type: 'uint48',
            },
            {
                indexed: false,
                internalType: 'uint48',
                name: 'oldNonce',
                type: 'uint48',
            },
        ],
        name: 'NonceInvalidation',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'token',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint160',
                name: 'amount',
                type: 'uint160',
            },
            {
                indexed: false,
                internalType: 'uint48',
                name: 'expiration',
                type: 'uint48',
            },
            { indexed: false, internalType: 'uint48', name: 'nonce', type: 'uint48' },
        ],
        name: 'Permit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'word',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'mask',
                type: 'uint256',
            },
        ],
        name: 'UnorderedNonceInvalidation',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DOMAIN_SEPARATOR',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'address', name: '', type: 'address' },
        ],
        name: 'allowance',
        outputs: [
            { internalType: 'uint160', name: 'amount', type: 'uint160' },
            { internalType: 'uint48', name: 'expiration', type: 'uint48' },
            { internalType: 'uint48', name: 'nonce', type: 'uint48' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'token', type: 'address' },
            { internalType: 'address', name: 'spender', type: 'address' },
            { internalType: 'uint160', name: 'amount', type: 'uint160' },
            { internalType: 'uint48', name: 'expiration', type: 'uint48' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'token', type: 'address' },
            { internalType: 'address', name: 'spender', type: 'address' },
            { internalType: 'uint48', name: 'newNonce', type: 'uint48' },
        ],
        name: 'invalidateNonces',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'wordPos', type: 'uint256' },
            { internalType: 'uint256', name: 'mask', type: 'uint256' },
        ],
        name: 'invalidateUnorderedNonces',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address', name: 'token', type: 'address' },
                    { internalType: 'address', name: 'spender', type: 'address' },
                ],
                internalType: 'struct IAllowanceTransfer.TokenSpenderPair[]',
                name: 'approvals',
                type: 'tuple[]',
            },
        ],
        name: 'lockdown',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '', type: 'address' },
            { internalType: 'uint256', name: '', type: 'uint256' },
        ],
        name: 'nonceBitmap',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint160', name: 'amount', type: 'uint160' },
                            { internalType: 'uint48', name: 'expiration', type: 'uint48' },
                            { internalType: 'uint48', name: 'nonce', type: 'uint48' },
                        ],
                        internalType: 'struct IAllowanceTransfer.PermitDetails[]',
                        name: 'details',
                        type: 'tuple[]',
                    },
                    { internalType: 'address', name: 'spender', type: 'address' },
                    { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
                ],
                internalType: 'struct IAllowanceTransfer.PermitBatch',
                name: 'permitBatch',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint160', name: 'amount', type: 'uint160' },
                            { internalType: 'uint48', name: 'expiration', type: 'uint48' },
                            { internalType: 'uint48', name: 'nonce', type: 'uint48' },
                        ],
                        internalType: 'struct IAllowanceTransfer.PermitDetails',
                        name: 'details',
                        type: 'tuple',
                    },
                    { internalType: 'address', name: 'spender', type: 'address' },
                    { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
                ],
                internalType: 'struct IAllowanceTransfer.PermitSingle',
                name: 'permitSingle',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permit',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint256', name: 'amount', type: 'uint256' },
                        ],
                        internalType: 'struct ISignatureTransfer.TokenPermissions',
                        name: 'permitted',
                        type: 'tuple',
                    },
                    { internalType: 'uint256', name: 'nonce', type: 'uint256' },
                    { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.PermitTransferFrom',
                name: 'permit',
                type: 'tuple',
            },
            {
                components: [
                    { internalType: 'address', name: 'to', type: 'address' },
                    { internalType: 'uint256', name: 'requestedAmount', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.SignatureTransferDetails',
                name: 'transferDetails',
                type: 'tuple',
            },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permitTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint256', name: 'amount', type: 'uint256' },
                        ],
                        internalType: 'struct ISignatureTransfer.TokenPermissions[]',
                        name: 'permitted',
                        type: 'tuple[]',
                    },
                    { internalType: 'uint256', name: 'nonce', type: 'uint256' },
                    { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.PermitBatchTransferFrom',
                name: 'permit',
                type: 'tuple',
            },
            {
                components: [
                    { internalType: 'address', name: 'to', type: 'address' },
                    { internalType: 'uint256', name: 'requestedAmount', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.SignatureTransferDetails[]',
                name: 'transferDetails',
                type: 'tuple[]',
            },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permitTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint256', name: 'amount', type: 'uint256' },
                        ],
                        internalType: 'struct ISignatureTransfer.TokenPermissions',
                        name: 'permitted',
                        type: 'tuple',
                    },
                    { internalType: 'uint256', name: 'nonce', type: 'uint256' },
                    { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.PermitTransferFrom',
                name: 'permit',
                type: 'tuple',
            },
            {
                components: [
                    { internalType: 'address', name: 'to', type: 'address' },
                    { internalType: 'uint256', name: 'requestedAmount', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.SignatureTransferDetails',
                name: 'transferDetails',
                type: 'tuple',
            },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'bytes32', name: 'witness', type: 'bytes32' },
            { internalType: 'string', name: 'witnessTypeString', type: 'string' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permitWitnessTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            { internalType: 'address', name: 'token', type: 'address' },
                            { internalType: 'uint256', name: 'amount', type: 'uint256' },
                        ],
                        internalType: 'struct ISignatureTransfer.TokenPermissions[]',
                        name: 'permitted',
                        type: 'tuple[]',
                    },
                    { internalType: 'uint256', name: 'nonce', type: 'uint256' },
                    { internalType: 'uint256', name: 'deadline', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.PermitBatchTransferFrom',
                name: 'permit',
                type: 'tuple',
            },
            {
                components: [
                    { internalType: 'address', name: 'to', type: 'address' },
                    { internalType: 'uint256', name: 'requestedAmount', type: 'uint256' },
                ],
                internalType: 'struct ISignatureTransfer.SignatureTransferDetails[]',
                name: 'transferDetails',
                type: 'tuple[]',
            },
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'bytes32', name: 'witness', type: 'bytes32' },
            { internalType: 'string', name: 'witnessTypeString', type: 'string' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'permitWitnessTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address', name: 'from', type: 'address' },
                    { internalType: 'address', name: 'to', type: 'address' },
                    { internalType: 'uint160', name: 'amount', type: 'uint160' },
                    { internalType: 'address', name: 'token', type: 'address' },
                ],
                internalType: 'struct IAllowanceTransfer.AllowanceTransferDetails[]',
                name: 'transferDetails',
                type: 'tuple[]',
            },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint160', name: 'amount', type: 'uint160' },
            { internalType: 'address', name: 'token', type: 'address' },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
export const ALLOWANCE_ABI = [
    {
        type: 'function',
        name: 'allowance',
        stateMutability: 'view',
        inputs: [
            {
                name: 'owner',
                type: 'address',
            },
            {
                name: 'spender',
                type: 'address',
            },
        ],
        outputs: [{ type: 'uint256' }],
    },
];
//# sourceMappingURL=abis.js.map